// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2127":"2184f8e0","2711":"9f645d83","4361":"25f439b4","4442":"25f439b4","5752":"25f439b4","5943":"25f439b4","6686":"25f439b4","7326":"25f439b4","7445":"25f439b4"}[chunkId] + ".chunk.css";
};